import TitleBarSpacer from "../../../components/layout/title_bar/TitleBarSpacer";
import TitleBarTitle from "../../../components/layout/title_bar/TitleBarTitle";
import Thumbnail from "../../../components/images/thumbnail/Thumbnail";
import TitleBar from "../../../components/layout/title_bar/TitleBar";
import { useGetPublicArtworks } from "../../../api/query_hooks";
import { getArtworkImageUrl } from "../../../api/endpoints";
import Panel from "../../../components/layout/panel/Panel";
import { Spinner } from "react-bootstrap";

const ExploreGallery = () => {
    
    const publicArtworksQuery = useGetPublicArtworks();


    return (
        <Panel>
            {publicArtworksQuery.isLoading && 
                <div className="bg-black d-flex justify-content-center align-items-center container">
                    <Spinner animation="border" role="status" aria-describedby="loading" />
                </div>
            }
            {publicArtworksQuery.isError && <></>}
            {publicArtworksQuery.isSuccess &&
                <>
                    <TitleBar className="bg-dark my-2 py-2 rounded">
                        <TitleBarSpacer width={3} />
                        <TitleBarTitle>Artworks from the community</TitleBarTitle>
                    </TitleBar>
                    <div className="d-flex flex-wrap col-12 mb-4">
                        {(publicArtworksQuery.isSuccess) &&
                        publicArtworksQuery.data?.data.map((artwork, index) => {
                            return(
                                <Thumbnail
                                    key={index}
                                    as="link"
                                    to={artwork.code && '/artworks/'+artwork.code}
                                    src={artwork.images?.length ? getArtworkImageUrl(artwork.images[0].path) : process.env.PUBLIC_URL+"/default_artwork.png"}
                                    className="position-relative p-1 w-33 w-lg-25 border-black border-2 rounded-3 overflow-hidden user-select-none"
                                />
                            )
                        })}
                    </div>
                </>
            }
        </Panel>
    );
}


export default ExploreGallery;